let MENUITEMS = [
  {
    Items: [
      {
        path: `/events`,
        icon: "ti-crown",
        type: "link",
        active: false,
        selected: false,
        title: "Events",
      },
      {
        path: `/category`,
        icon: "fas fa-layer-group",
        type: "link",
        active: false,
        selected: false,
        title: "Category",
      },
    ],
  },
];

export { MENUITEMS };
